type SupportedMoneyUnit =
  | 'UNIT_UNSPECIFIED'
  | 'UNIT_WHOLE'
  | 'UNIT_CENTI'
  | 'UNIT_MILLI'
  | 'UNIT_MICRO';

type MoneyWithUnit = {
  amount?: string;
  unit?: string;
};

const UNIT_DIVISORS: Record<SupportedMoneyUnit, number> = {
  UNIT_UNSPECIFIED: 1,
  UNIT_WHOLE: 1,
  UNIT_CENTI: 100,
  UNIT_MILLI: 1000,
  UNIT_MICRO: 1000000,
};

export const normaliseMoneyAmount = (
  price: MoneyWithUnit | undefined,
): number | null => {
  if (price?.amount == null || price.unit == null) return null;

  const raw = Number.parseFloat(price.amount);

  if (Number.isNaN(raw)) return null;

  const divisor =
    price.unit in UNIT_DIVISORS
      ? UNIT_DIVISORS[price.unit as SupportedMoneyUnit]
      : 1;

  return raw / divisor;
};
